// @flow
import * as React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { translate } from 'react-i18next';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
`;

const DateText = styled(Text)`
  font-size: ${({ theme }) => theme.fonts.style.xsmall.fontSize}px;
`;

const Icon = styled(Text)`
  font-size: ${({ theme }) => theme.metrics.icon.tiny.width}px;
  margin-right: ${({ theme }) => theme.metrics.smallMargin}px;
`;

type Props = {
  date: moment;
  withIcon: boolean;
  t: (any, any) => string;
};

const DateDisplay = ({ date, withIcon, t }: Props) => {
  return (
    <Wrapper>
      {withIcon && <Icon className="material-icons">date_range</Icon>}
      <DateText>
        {t('date.standard', { value: date })}
      </DateText>
    </Wrapper>
  );
};

DateDisplay.defaultProps = {
  withIcon: true,
};

export default translate()(DateDisplay);



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/components/DateDisplay.js